import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_LogTemplate } from '@app/hcs-shared';
export const dispatch_onLogTemplatesUpdated = new ThunderDispatcherV3('__onLogTemplatesUpdated');
export class ModuleFE_LogTemplate_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_LogTemplate, dispatch_onLogTemplatesUpdated);
    }
}
export const ModuleFE_LogTemplate_OLD = new ModuleFE_LogTemplate_Class();
//# sourceMappingURL=ModuleFE_LogTemplate_OLD.js.map